import { CSVImporter } from "csv-import-react";
import { COLORS } from "@/react/theme/constants";

export function OxygenTableFlowImporter(props) {
  return <CSVImporter primaryColor={COLORS.danger} {...props} />;
}
